import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=1182bb54&scoped=true"
import script from "./StartScreen.vue?vue&type=script&lang=js"
export * from "./StartScreen.vue?vue&type=script&lang=js"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=1182bb54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1182bb54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1182bb54')) {
      api.createRecord('1182bb54', component.options)
    } else {
      api.reload('1182bb54', component.options)
    }
    module.hot.accept("./StartScreen.vue?vue&type=template&id=1182bb54&scoped=true", function () {
      api.rerender('1182bb54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/default/StartScreen.vue"
export default component.exports